import { Alert, Box, Card, Dialog, Grid, Stack } from '@mui/material';

import { LoadingButton } from '@mui/lab';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import { observer } from 'mobx-react-lite';
import { useSnackbar } from 'notistack';

import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import useLocales from 'src/hooks/useLocales';
import { useStore } from 'src/stores/store';
interface Props {
  id: number;
}

export default observer(function ContractInfoDelete({ id }: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const { translate } = useLocales();
  const { ContractInfoStore } = useStore();
  const validationSchema = Yup.object().shape({
    remarks: Yup.string()
      .required(`${translate('Validation.Remark')}`)
      .label('Remark'),
  });
  const methods = useForm<any>({
    resolver: yupResolver(validationSchema),
  });

  const {
    reset,
    handleSubmit,
    setError,
    formState: { isSubmitting, errors },
  } = methods;

  const onSubmit = (remark: string) => {
    ContractInfoStore.deleteContractInfo(id, remark)
      .then(() => {
        enqueueSnackbar(`${translate('Tostar.DeleteSuccess')}`);
      })
      .catch((err) => {
       
        var json = JSON.parse(err.request.response);
        if (json.message != null) {
          setError('afterSubmit', { ...err, message: json.message });
        }
      });
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      {!!errors.afterSubmit && (
        <Alert sx={{ mb: 2 }} severity="error">
          {errors.afterSubmit.message}
        </Alert>
      )}
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={10} md={10}>
            <Box
              sx={{
                ml: 4,
                mt: 4,
                mb: 4,
              }}
            >
              <Stack spacing={2}>
                <RHFTextField
                  name="remarks"
                  label={translate('CRUD.Remarks')}
                  size="small"
                  autoFocus
                />
              </Stack>
            </Box>
            <Box
              sx={{
                ml: 4,
                mt: 4,
                mb: 4,
              }}
            >
              <Stack direction="row" spacing={3}>
                <LoadingButton
                  type="submit"
                  variant="contained"
                  size="small"
                  color="error"
                  loading={isSubmitting}
                  startIcon={<DeleteIcon />}
                >
                  {translate('CRUD.Delete')}
                </LoadingButton>

                <LoadingButton
                  variant="contained"
                  size="small"
                  onClick={() => ContractInfoStore.setOpenCloseDialog()}
                  startIcon={<CancelIcon />}
                >
                  {translate('CRUD.Cancle')}
                </LoadingButton>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </FormProvider>
  );
});
